<script setup>
import { defineProps } from "vue";
defineProps({
  type: {
    type: String,
    default: "info",
  },
});
</script>

<template>
  <div class="alert" :class="[type]">
    <i
      class="fa-exclamation-circle fas mr-0-5"
      aria-hidden="true"
      v-if="type === 'error'"
    ></i>
    <i
      class="fa-check-circle fas mr-0-5"
      aria-hidden="true"
      v-if="type === 'success'"
    ></i>
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.alert {
  background-color: whitesmoke;
  border: 1px solid #ccc;
  color: black;
  padding: 10px;
  border-radius: 5px;
  &.error {
    background-color: #ffcaca;
    border-color: #ff5050;
    color: #ff2121;
  }

  &.success {
    background-color: #d4edda;
    border-color: #c3e6cb;
    color: #155724;
  }
}
</style>
